"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var core_1 = require("stremio/core");
var useExternalPlayerCallback = function (urlParams, metaDetails) {
    var core = (0, core_1.useCore)();
    var _a = (0, react_router_dom_1.useSearchParams)(), searchParams = _a[0], setSearchParams = _a[1];
    var callbackRef = react_1.default.useRef(null);
    react_1.default.useEffect(function () {
        var _a, _b;
        var position = searchParams.get('position');
        if (position === null || position === '') {
            return;
        }
        var positionNumber = Number(position);
        var time = Math.round(positionNumber * 1000);
        var streamPath = (_b = (_a = metaDetails.selected) === null || _a === void 0 ? void 0 : _a.streamPath) !== null && _b !== void 0 ? _b : null;
        var callbackKey = [
            urlParams.type,
            urlParams.id,
            urlParams.videoId,
            time,
            searchParams.get('lastPlayedUrl')
        ].join(':');
        if (!Number.isFinite(positionNumber) ||
            positionNumber < 0 ||
            streamPath === null ||
            metaDetails.libraryItem === null ||
            callbackRef.current === callbackKey) {
            return;
        }
        callbackRef.current = callbackKey;
        core.transport.dispatch({
            action: 'MetaDetails',
            args: {
                action: 'ExternalPlayerProgressChanged',
                args: {
                    time: time
                }
            }
        });
        var nextSearchParams = new URLSearchParams(searchParams);
        nextSearchParams.delete('position');
        nextSearchParams.delete('lastPlayedUrl');
        setSearchParams(nextSearchParams, { replace: true });
    }, [urlParams, searchParams, setSearchParams, metaDetails]);
};
exports.default = useExternalPlayerCallback;
